import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";

import { StoreHelper } from "../helpers/store.helper";
import { environment } from "../../../environments/environment";

@Injectable()
export class HeaderService {
  private headers = new HttpHeaders();
  private baseUrl = "";
  private user = null;

  constructor() {
    this.headers = this.headers.set("Content-Type", "application/json");
    this.headers = this.headers.set("Cache-Control", "no-cache");
    this.headers = this.headers.set("Cache-Control", "no-store");
    this.headers = this.headers.set("Pragma", "no-cache");
    this.headers = this.headers.set("If-Modified-Since", "0");
    this.headers = this.headers.set("Expires", "0");
    this.headers = this.headers.set("Instance-Type", environment.instanceType);
    this.baseUrl = environment.apiUrl + "/ub2/";
  }

  // In-memory access token, set by AuthService
  private _token: string | null = null;

  setToken(token: string | null) {
    this._token = token;
    if (token) {
      this.headers = this.headers.set("Authorization", 'Bearer: ' + token);
    } else {
      this.headers = this.headers.delete('Authorization');
    }
  }

  // set Auth-Token from in-memory token
  createAuthorizationHeader() {
    if (this._token) {
      this.headers = this.headers.set("Authorization", 'Bearer: ' + this._token);
    } else {
      this.headers = this.headers.delete('Authorization');
    }
  }

  getUser() {
    return this.user;
  }

  getHeaders() {
    return this.headers;
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  getError(error) {
    if (error._body) {
      const body = error._body.split("|");
      if (body.length > 1) {
        return body[1];
      }
    }
    return error.statusText;
  }
}
